import React from 'react';

import { BsDiscord, BsTwitterX } from 'react-icons/bs';
import { HiDocument } from 'react-icons/hi2';
import { PiTelegramLogo } from 'react-icons/pi';

import { cn } from '@/utils';

import { HeaderMenuDrawerSingle } from '../HeaderMenuDrawerComponents';

const HeaderMenuDrawerLinks: React.FC = () => {
  return (
    <div className="flex flex-col justify-end gap-2">
      <HeaderMenuDrawerSingle href="https://docs.pactswap.io/documents/PactSwap-Whitepaper.pdf" Icon={HiDocument}>
        Whitepaper
      </HeaderMenuDrawerSingle>

      {/* 
      Litepaper is obsolete, hidden for now
      <HeaderMenuDrawerSingle href="https://docs.pactswap.io/documents/PactSwap-Litepaper.pdf" Icon={HiDocument}>
        Litepaper
      </HeaderMenuDrawerSingle> */}

      <HeaderMenuDrawerSingle
        href="https://docs.coinweb.io/learn/usecases/pact"
        Icon={(props) => (
          <img src="/chains/coinweb.svg" className={cn('brightness-[1000%] grayscale', props.className)} />
        )}
      >
        PACT
      </HeaderMenuDrawerSingle>

      <HeaderMenuDrawerSingle href="https://t.me/PACTSWAPDEX" Icon={PiTelegramLogo}>
        Telegram
      </HeaderMenuDrawerSingle>

      <HeaderMenuDrawerSingle href="https://x.com/pact_swap" Icon={BsTwitterX}>
        X Social
      </HeaderMenuDrawerSingle>

      <HeaderMenuDrawerSingle href="https://discord.gg/pactswap" Icon={BsDiscord}>
        Discord
      </HeaderMenuDrawerSingle>

      <HeaderMenuDrawerSingle
        href="https://pactswap.io"
        Icon={(props) => <img src="/cwap/Logo_White.svg" {...props} />}
      >
        pactswap.io
      </HeaderMenuDrawerSingle>
    </div>
  );
};

export default HeaderMenuDrawerLinks;
